import { createRecurrenceTracker, resolveScheduleRoot } from "#/admin/legacy/schedules/schedule-recurrence.js";

(function ($) {
  window.ScheduleForm = function (container) {
    var recurrenceMembersSelector = "#recurrence_members";
    const recurrenceChanged = createRecurrenceTracker(resolveScheduleRoot(container));

    // BEHAVIOUR
    jQuery(container).on("change", "[data-behaviour~=update-repeat-select]", updateRepeatSelect);
    jQuery(container).on("click", "[data-behaviour~=toggle-selected-date]", toggleSelectedDate);

    // EVENT HANDLERS

    function updateRepeatSelect(event) {
      if (recurrenceChanged(event.currentTarget)) {
        clearRecurrenceMembers();
      }
    }

    function toggleSelectedDate(event) {
      event.preventDefault();
      jQuery(this).toggleClass("active");
      updateRecurrenceMembers();
    }

    // HELPERS

    function updateRecurrenceMembers() {
      var selectedDates = [];

      jQuery(container)
        .find(".calendar")
        .find(".active")
        .map(function () {
          selectedDates.push(jQuery(this).text());
        });

      jQuery(recurrenceMembersSelector).val(selectedDates.join(","));
    }

    function clearRecurrenceMembers() {
      jQuery(container).find(recurrenceMembersSelector).val("");
      jQuery(targetSelector(recurrenceMembersSelector)).filter("a").removeClass("active");
    }

    function targetSelector(target) {
      return "[data-target='" + target + "']";
    }
  };
})(jQuery);
